/* eslint-env browser */
var resize = require('./resize')
var notices = require('../../notices');
var photoUploadSpinner = require('../../photo-upload/photo-upload-ajax/lib/spinner');
var config = require('../../config').config;
var raygun = require('../../raygun');

// Given the user is uploading a photo
// When a file has been captured by a file input
// Then convert the file to an img
// And resize the img
// And display ui.spinner
window.chrome || ['createObjectURL', 'revokeObjectURL'].map(function(i) {
  window.URL[i] && (window.URL[i] = window.URL[i].bind(window.URL))
})
var filedata;

var uuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = 16 * Math.random() | 0
    return (c === 'x' ? r : 3 & r | 8).toString(16)
  })
}

var onchangeHandler = function(e) {
  var form = e.target.form;

  if (e.target.dataset.imageUpload) {

    var file = e.target.files[0]

    if(/image\/(jpe?g|png|bmp|gif)/.test(file.type)) {
      var img = new Image()
      img.onload = function(e){
        resize(e, function(blob){

          var uploadLocation = document.getElementById('uploadLocation').value;
            var uploadEmid = document.getElementById('uploadEmid').value;

          var previewImage = form.querySelector('[data-preview]');
          previewImage.classList.remove('hide');
          previewImage.innerHTML = '';
          var newImg = document.createElement('img'),
            url = URL.createObjectURL(blob);

          newImg.onload = function() {
            // no longer need to read the blob so it's revoked
            URL.revokeObjectURL(url);
          };

          newImg.src = url;
          newImg.classList.add('fit')
          previewImage.appendChild(newImg);
          previewImage.classList.remove('hide')

          filedata = new FormData();
          filedata.append("fileData", blob, uuid() + '.jpg');
          filedata.append("originalFileSize", file.size);
          filedata.append("uploadLocation", uploadLocation);
          if(uploadEmid){
            filedata.append("uploadEmid", uploadEmid);
          }
        });
      }

      img.src = URL.createObjectURL(file)
      URL.revokeObjectURL(file)
      var submitButton = form.querySelector('[type=submit]')
      if(submitButton){
        submitButton.removeAttribute('disabled')
        if(submitButton.classList.contains('hide')){
          submitButton.classList.remove('hide')
        }
      }

    } else {
      notices.warn();
    }

  }
}

var post = function(url, data) {

 return fetch(url, {
    method: 'POST',
    credentials: "same-origin",
    body: data,
    headers:{
      'Accept':'application/vnd.cupidmedia.html, image/*'
    }
    })
   .then(function(response) {
     if(response.ok){
       return response.json();
     }
   })
   .then(function (response) {
     if(response.status == -100){ //logged out
       window.location.href = response.redirectLink
     }

     return response
   })
}

var onsubmitHandler = function(e) {
  var form = e.target;
  if (form.dataset.imageUploader && filedata) {
    e.preventDefault();
    photoUploadSpinner.hidden=false;

    post('/'+config.translationPath.trim()+'/widget/saveUploadedImage?ajaxMode=true', filedata)
      .then(function(response){

        if(response.success == true){
          form.elements.attachmentID.value = response.result;
          var fileInput = form.elements.attachmentFile;

          if (fileInput) {
            fileInput.remove();
          }
          form.submit()

        } else {
          photoUploadSpinner.hidden = true;
          notices.warn(response.errormessage);
        }
      })
      .catch(function(response){
        photoUploadSpinner.hidden=true;
        form.reset()
        notices.warn(response.errormessage);
        raygun.sendError(error, 'saveUploadedImage');
      })

  }
}

window.addEventListener('change', onchangeHandler)
window.addEventListener('submit', onsubmitHandler, true)